<script>

import Vue from 'vue'

function treewalk (_t, _n) {
  _n.forEach((n) => {
    if (n.tag) {
      _t.push('<', n.tag)
      const attrs = n.data?.attrs || []
      Object.keys(attrs).forEach(key => {
        _t.push(' ', key, '="', attrs[key], '"')
      })

      const staticClass = n.data?.staticClass || ''
      if (staticClass !== '') {
        _t.push(' class="', staticClass, '"')
      }
      _t.push('>')
      if (n.children && n.children.length > 0) {
        treewalk(_t, n.children)
      } else if (n.data && n.data.domProps) {
        _t.push(n.data.domProps.innerHTML)
      }
      _t.push('</', n.tag, '>')
    } else {
      _t.push(n.text)
    }
  })
}
export default {
  name: 'dyn-slot',
  props: {
    slotData: {},
    cleanUp: {
      type: Boolean,
      default: false
    },
    hideParentEnvironment: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: 'span'
    },
    useVHTML: {
      type: Boolean,
      default: false
    }
  },

  render (createElement, context) {
    if (this.hideParentEnvironment) {
      if (this.res.staticRenderFns.length > 0) {
        return this.res.staticRenderFns[0].call(this)
      }
      return this.res.render.call(this, createElement)
    }
    // parent env ist not hidden. so the slotData will be mapped into parent slot
    const parentSlotData = this.$parent.slotData
    if (this.slotData) this.$parent.slotData = this.slotData

    let result = null
    if (this.res.staticRenderFns.length > 0) {
      result = this.res.staticRenderFns[0].call(this.$parent)
    } else {
      result = this.res.render.call(this.$parent, createElement)
    }
    if (typeof parentSlotData !== 'undefined') this.$parent.slotData = parentSlotData
    else delete (this.$parent.slotData)
    return result
  },
  mounted () {
    if (this.doCleanUp === true) {
      this.$nextTick(function () {
        // select element to unwrap
        const el = document.getElementById('dyn_' + this._uid)
        if (el !== null) {
          // get the element's parent node
          const parent = el.parentNode
          // move all children out of the element
          while (el.firstChild) parent.insertBefore(el.firstChild, el)
          // remove the empty element
          parent.removeChild(el)
        }
      })
    }
  },
  created () {
    // debugger
    const _n = this._self._t('default')

    var _t = ['<', this.tag]

    if (this.cleanUp || !_n) {
      _t.push(' id="dyn_', this._uid, '"')
    }

    if (this.class) {
      _t.push(' class="', this.class, '"')
    }
    _t.push('>')

    if (_n) {
      treewalk(_t, _n)
      this.doCleanUp = this.cleanUp
    } else {
      this.doCleanUp = true
    }
    _t.push('</', this.tag, '>')
    let _html = _t.join('')
    if (this.useVHTML) {
      _html = _html.replace(/{{/gi, '<dyn-vhtml v-html="').replace(/}}/gi, '"></dyn-vhtml>')
    }
    this.res = Vue.compile(_html)
  }
}
</script>
